import React, { useState } from 'react';
import { Props } from './interfaces';
import './Textarea.scss';
import './Textarea-media.scss';
import ErrorText from '../ErrorText/ErrorText';
import {content} from "../../services/content";
import {textareaMaxSymbols} from "../../services/content/Constants";

const Textarea = ({
  placeholder = '',
  value,
  label,
  onChange,
  error,
  resize = true,
  marginTop = '32px',
}: Props) => {
  const [countSymbols, setCountSymbols] = useState(value?.length);

  return (
    <div className="textarea">
      {label ? (
        <p className="textarea__label" style={{ marginTop }}>
          {label}
        </p>
      ) : null}
      <textarea
        className="textarea__field"
        placeholder={placeholder}
        defaultValue={value}
        onChange={(e) => {
          setCountSymbols(e.target.value.length);
          onChange(e);
        }}
        maxLength={500}
        style={!resize ? { resize: 'none' } : {}}
      ></textarea>
      <div className="textarea__counter">
        <p>{content.textareaConstants.max}</p>
        <p>{countSymbols}/{textareaMaxSymbols}</p>
      </div>
      {error ? ErrorText(error) : null}
    </div>
  );
};

export default Textarea;
